import React from 'react';
import DefaultWidthContainer from '../../Layout/Containers/DefaultWidthContainer';
import FullWidthContainer from '../../Layout/Containers/FullWidthContainer';
import HeadingAndTextContainer from '../../Layout/Containers/HeadingAndTextContainer/HeadingAndTextContainer';
import LargeWidthContainer from '../../Layout/Containers/LargeWidthContainer';
import ContactBannerComponent from '../../util/ContactComponent/ContactBannerComponent';
import styles from './cloudOperations.module.scss';
import { servicesData } from './servicesData';
import RelatedServicesComponentRender from '../../RelatedServices/RelatedServicesComponentRender';
import BreadcrumbsComponent from '../../Breadcrumbs/BreadcrumbsComponent';

const crumbs = [
    {
        url: '/services',
        name: 'Services',
    },
    {
        url: '/services/cloud-operations',
        name: 'Cloud Operations',
    },
    {
        url: '/services/cloud-operations/cloud-hosting',
        name: 'Cloud Hosting',
    },
];

const CloudHostingComponent = () => (
    <>
        <DefaultWidthContainer>
            <BreadcrumbsComponent crumbs={crumbs} />
        </DefaultWidthContainer>
        <FullWidthContainer>
            <HeadingAndTextContainer
                ingress="Cloud Hosting"
                ingressSize="big"
                h1={true}
                paragraphSize="small"
            >
                <p>
                    As a SaaS company, the team at Noria are experts on hosting and operating
                    software applications in the cloud. We help you run and operate your services
                    and solutions through our partnership with Microsoft Azure.
                </p>
            </HeadingAndTextContainer>
        </FullWidthContainer>
        <LargeWidthContainer>
            <div className={styles.illustration}>
                <img src="/images/services/cloud-hosting.png" alt="cloud hosting" width="30%" />
            </div>
        </LargeWidthContainer>
        <DefaultWidthContainer>
            <div className={styles.doubleParagraphContainer}>
                <div className={styles.column}>
                    <h2>Cloud hosting offerings</h2>
                    <ul>
                        <li>We manage and run your applications.</li>
                        <li>Integrations with you DevOps stack.</li>
                        <li>Cloud advisory.</li>
                    </ul>
                </div>
                <div className={styles.column}>
                    <h2>Benefits</h2>
                    <ul>
                        <li>Micrsoft Azure partner.</li>
                        <li>SLA on operation and support.</li>
                        <li>ISAE 3402 type 2 certification.</li>
                    </ul>
                </div>
            </div>
        </DefaultWidthContainer>
        <DefaultWidthContainer>
            <RelatedServicesComponentRender
                services={servicesData}
                currentServiceKey={'CLOUD_OPERATIONS_CLOUD_HOSTING'}
            ></RelatedServicesComponentRender>
        </DefaultWidthContainer>
        <ContactBannerComponent heading={'Questions about Managed IT?'} isReadyForDemo={false}>
            {
                <>
                    <div>
                        <p>Sindre Fjogstad - Commercial</p>
                        <a href="mailto:sindre.fjogstad@noria.no?subject=Queries/Demo – Cloud Operations&body=Hi, Sindre Fjogstad">
                            Contact Sindre
                        </a>
                    </div>
                    <div>
                        <p>Egil Opstad - Technical</p>
                        <a href="mailto:egil.opstad@noria.no@noria.no?subject=Queries/Demo – Cloud Operations&body=Hi, Egil Opstad">
                            Contact Egil
                        </a>
                    </div>
                </>
            }
        </ContactBannerComponent>
    </>
);

export default CloudHostingComponent;
